import TpkSelectOptions from '../tpk-select/options';
export default class TpkSelectSearchOptions extends TpkSelectOptions {}